import { render, staticRenderFns } from "./pick.vue?vue&type=template&id=8bf92826&scoped=true&"
import script from "./pick.vue?vue&type=script&lang=js&"
export * from "./pick.vue?vue&type=script&lang=js&"
import style0 from "./pick.vue?vue&type=style&index=0&id=8bf92826&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf92826",
  null
  
)

export default component.exports